import { render, staticRenderFns } from "./ThemesEditorSearchBtn.vue?vue&type=template&id=3e2e5c30"
import script from "./ThemesEditorSearchBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorSearchBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports